import { QuestionBase } from './question-base.model';

export class ImageEditorQuestion extends QuestionBase<string> {
    controlType = 'imageEditor';
    datasource: any;
    visible: string;
    type: any;

    constructor(options: {} = {}) {
        super(options);
        this.datasource = options['datasource'];
        this.type = options['type'] ? options['type'] : "String"
        this.visible = (options['visible'] == undefined) ? true : options['visible'];
    }
}